module.exports = __webpack_public_path__ + "img/icon1.70ed574.jpg";